import React from 'react';
import { motion } from 'framer-motion';

const AboutPage = () => {
  return (
    <div className="pt-16">
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">About Us</h1>
            <p className="text-xl text-gray-600">
              Transforming lives through dignity, empowerment, and sustainable solutions
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="prose prose-lg mx-auto"
          >
            <p className="text-gray-700 leading-relaxed mb-6">
              Begging Free India Foundation was born from a simple yet powerful belief: every individual deserves dignity, 
              opportunity, and the chance to build a better future. We are not just another charity organization – we are 
              a movement dedicated to addressing the root causes of begging and creating sustainable pathways to independence.
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Our approach is holistic and human-centered. We don't just provide temporary relief; we create lasting change 
              through comprehensive rehabilitation programs that address shelter, healthcare, skill development, and psychological 
              support. Every person who comes to us is treated with respect and given the tools they need to rebuild their lives.
            </p>
            
            <p className="text-gray-700 leading-relaxed">
              Since our inception, we have transformed thousands of lives, creating a ripple effect of positive change that 
              extends to families and communities. Our vision is ambitious but achievable: a begging-free India where every 
              citizen has the opportunity to live with dignity and contribute meaningfully to society.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;